module.exports = __webpack_public_path__ + "efd907390f23784e2a2c2e2eea9aa81a.png";